export const glossaryTerms = [
  // Core concept
  {
    term: "ONE Score",
    definition: "The overall weighted average score of the metrics, used to track overall performance. It's an ad-hoc score generated for the perfect execution of each specific Digital Storefront.",
    category: "Core concept",
  },
  {
    term: "Refresh",
    definition: "The historical data point used for comparison (e.g., to calculate \"Change\" metrics).",
    category: "Core concept",
  },
  {
    term: "Digital Storefront",
    definition: "The digital representation of a physical location online (e.g., a restaurant listed on UberEats, DoorDash, or GrubHub).",
    category: "Core concept",
  },
  {
    term: "Physical Location",
    definition: "The physical location, can be associated with multiple digital storefronts.",
    category: "Core concept",
  },

  // Core View
  {
    term: "Internal Configuration Page",
    definition: "Shows a table for each market with the weights applied to each DashONE KPI.",
    category: "Core View",
  },
  {
    term: "Execution View",
    definition: "A dashboard view on the Digital Storefront level that contains all digital storefronts Dashmote is able to scrape in the market for the platforms in scope.",
    category: "Core View",
  },
  {
    term: "Physical Location View",
    definition: "A dashboard view where metrics and KPIs are aggregated and presented at the level of the physical outlet.",
    category: "Core View",
  },
  {
    term: "My List",
    definition: "Directory of all lists generated by the user. These list track overtime performance of the execution efforts.",
    category: "Core View",
  },
  {
    term: "Market Overview Page",
    definition: "A multi-market dashboard with over-time data, allowing leadership to track performance across multiple markets and DashONE metrics.",
    category: "Core View",
  },
  {
    term: "Market Deep Dive Page",
    definition: "A market-specific dashboard that focuses on over-time comparison.",
    category: "Core View",
  },

  // Dashboard Feature
  {
    term: "Save List Button",
    definition: "Allows the user to create a customized list of outlets or digital storefronts that they want to track over time.",
    category: "Dashboard Feature",
  },
  {
    term: "Download Button",
    definition: "Allows the user to download the data from the view they are currently on.",
    category: "Dashboard Feature",
  },
  {
    term: "Search Bar",
    definition: "Allows the user to search for a specific digital storefront, physical outlet, or address.",
    category: "Dashboard Feature",
  },
  {
    term: "Refresh Drop-Down",
    definition: "Allows the user to select the month they want to look at.",
    category: "Dashboard Feature",
  },
  {
    term: "Compare To Drop-Down",
    definition: "Allows the user to select the month they want to compare the selected refresh to.",
    category: "Dashboard Feature",
  },
  {
    term: "Filter Sidebar",
    definition: "Allows the user to filter the data by platform, category, brand, and more.",
    category: "Dashboard Feature",
  },
  {
    term: "Collapse/Expand Button",
    definition: "Hides or shows all the outlet information.",
    category: "Dashboard Feature",
  },
  {
    term: "Export Button",
    definition: "Allows the user to generate an Excel sheet export of the data.",
    category: "Dashboard Feature",
  },
  {
    term: "Hide Filter",
    definition: "Hides the currently applied filter selection.",
    category: "Dashboard Feature",
  },
  {
    term: "Plus Button (+)",
    definition: "Allows the user to create an additional ad-hoc set of columns (Availability, Bundles, Content) for a specific SKU (at company, brand, sub-brand, or SKU level).",
    category: "Dashboard Feature",
  },
  {
    term: "Save Filter View Button",
    definition: "Allows the user to create a custom macro or use case by saving a specific filtering selection.",
    category: "Dashboard Feature",
  },

  // KPIs (ONE Metrics)
  {
    term: "Core Brand Availability",
    definition: "The percentage of digital storefronts listing at least one of my core brands.",
    category: "KPIs (ONE Metrics)",
  },
  {
    term: "Core Brand Availability (Weighted)",
    definition: "The core brand availability weighted by the importance of the platforms.",
    category: "KPIs (ONE Metrics)",
  },
  {
    term: "Competitor Availability",
    definition: "The percentage of digital storefronts listing at least one of my competitors' brands.",
    category: "KPIs (ONE Metrics)",
  },
  {
    term: "Combo Presence",
    definition: "The percentage of digital storefronts listing at least one of my products in a combo.",
    category: "KPIs (ONE Metrics)",
  },
  {
    term: "Fixed Combo Presence",
    definition: "The percentage of digital storefronts listing at least one of my products in a fixed combo (a combo where the drink cannot be changed).",
    category: "KPIs (ONE Metrics)",
    exampleImage: "fixed combo example.png",
  },
  {
    term: "Option Combo Presence",
    definition: "The percentage of digital storefronts listing at least one of my products in an option combo (a combo where the user can select multiple drinks).",
    category: "KPIs (ONE Metrics)",
    exampleImage: "option combo example.png",
  },
  {
    term: "Name Completeness",
    definition: "The average name completeness score across all of my SKUs sold in the market.",
    category: "KPIs (ONE Metrics)",
    exampleImage: "name completeness example.png",
  },
  {
    term: "Image Presence",
    definition: "The average image presence score across all of my SKUs sold in the market.",
    category: "KPIs (ONE Metrics)",
    exampleImage: "image presence example.png",
  },

  // KPIs (Scorecard)
  {
    term: "My Availability",
    definition: "The number of Digital Storefronts that are listing my products.",
    category: "KPIs (Scorecard)",
  },
  {
    term: "Combo",
    definition: "The total number of Digital Storefronts listing my products in a combo.",
    category: "KPIs (Scorecard)",
  },
  {
    term: "Competitor Availability",
    definition: "The total number of Digital Storefronts that are listing the competitor's products.",
    category: "KPIs (Scorecard)",
  },
  {
    term: "Full Core Availability",
    definition: "The number of Digital Storefronts that are listing my full core brand portfolio (e.g., all selected core products must be listed).",
    category: "KPIs (Scorecard)",
  },
  {
    term: "Image Presence",
    definition: "The total number of Digital Storefronts listing my product with an image.",
    category: "KPIs (Scorecard)",
    exampleImage: "image presence example.png",
  },
  {
    term: "Name Completeness",
    definition: "The total number of Digital Storefronts listing my product with perfect naming (naming convention).",
    category: "KPIs (Scorecard)",
    exampleImage: "name completeness example.png",
  },
  {
    term: "Total Universe",
    definition: "The total number of Digital Storefronts Dashmote is able to scrape in the market for the platforms in scope.",
    category: "KPIs (Scorecard)",
  },
  {
    term: "Total Universe (Drinks)",
    definition: "The total number of Digital Storefronts that are listing drinks from the brand list.",
    category: "KPIs (Scorecard)",
  },

  // Market Deepdive View
  {
    term: "Core Brands Penetration Graph",
    definition: "An over-time graph showing how many stores are listing up to one core brand, up to two core brands, up to three, etc., up until eight.",
    category: "Market Deepdive View",
  },
  {
    term: "Performance Trends Analysis Graph",
    definition: "An over-time graph that allows the user to select and track one metric at a time (e.g., ONS, Availability, Combo Presence, etc.).",
    category: "Market Deepdive View",
  },
  {
    term: "Retention, Acquisition, and Churn Graph",
    definition: "Tracks over time how many Digital Storefronts/products have been won (acquired), lost (churned), and consistent (retained) for both the myself and the competition.",
    category: "Market Deepdive View",
  },
  {
    term: "Opportunity Analysis Graph - Gaps",
    definition: "Stores that are not listing my drink.",
    category: "Market Deepdive View",
  },
  {
    term: "Opportunity Analysis Graph - Opportunities",
    definition: "Stores that are not listing my drink and not listing the competitor's drink.",
    category: "Market Deepdive View",
  },
  {
    term: "Opportunity Analysis Graph - No Portfolio",
    definition: "Stores that are not listing any drink from the Brand List.",
    category: "Market Deepdive View",
  },

  // Execution View
  {
    term: "Score",
    definition: "The DashONE Score for that specific Digital Storefront in the latest refresh.",
    category: "Execution View",
  },

  // Market Data (renamed to Outlet Data in some terms)
  {
    term: "Total Digital Storefronts",
    definition: "The total number of unique digital storefronts (e.g., McDonald's on UberEats) found in a market.",
    category: "Market Data",
  },
  {
    term: "Total Physical Locations",
    definition: "The total number of unique physical locations (e.g., one specific McDonald's address) found in a market.",
    category: "Market Data",
  },
  {
    term: "Matched Physical Locations",
    definition: "Physical locations that have been matched to a specific customer's CRM ID.",
    category: "Market Data",
  },
  {
    term: "Market",
    definition: "The geographical area being analyzed (usually a country or city).",
    category: "Market Data",
  },
  {
    term: "Platform",
    definition: "The delivery or aggregator platform (e.g., UberEats, DoorDash, Glovo).",
    category: "Market Data",
  },

  // Outlet Data
  {
    term: "Outlet Name",
    definition: "The name of the physical location or digital storefront.",
    category: "Outlet Data",
  },
  {
    term: "Address",
    definition: "The physical address in which the Digital Storefront is found.",
    category: "Outlet Data",
  },
  {
    term: "City",
    definition: "The city in which the location is found.",
    category: "Outlet Data",
  },
  {
    term: "Change is Going Up",
    definition: "The DashONE score for this DSF got higher compared to the previous refresh. This means that the store is getting better in their quest for perfect execution",
    category: "Outlet Data",
  },
  {
    term: "Change is Going Down",
    definition: "The DashONE score for this DSF got lower compared to the previous refresh. This means that the store is starting to remove items, images, or combos, which is hurting its perfect execution score",
    category: "Outlet Data",
  },
  {
    term: "Change is Consistent",
    definition: "The DashONE score for this DSF stayed the same compared to the previous refresh.",
    category: "Outlet Data",
  },
  {
    term: "Change is N/A",
    definition: "This is a new store and this is the first time this DSF gets assigned a DashONE. Hence, it can't be compared to a previous refresh",
    category: "Outlet Data",
  },
  {
    term: "CRM ID",
    definition: "The CRM ID that has been matched to the specific location.",
    category: "Outlet Data",
  },
  {
    term: "Cuisine",
    definition: "The cuisine type provided by the platform.",
    category: "Outlet Data",
  },
  {
    term: "Franchise",
    definition: "A column that indicates if a store belongs to a specific franchise.",
    category: "Outlet Data",
  },
  {
    term: "Geo Level 1",
    definition: "The region in which the location is found.",
    category: "Outlet Data",
  },
  {
    term: "Geo Level 2",
    definition: "The province in which the location is found.",
    category: "Outlet Data",
  },
  {
    term: "Google ID",
    definition: "The Google Place ID of the location",
    category: "Outlet Data",
  },
  {
    term: "In CRM",
    definition: "A Boolean value indicating if the location was successfully matched to a CRM ID.",
    category: "Outlet Data",
  },
  {
    term: "On Google",
    definition: "A Boolean column indicating if the location was found on Google.",
    category: "Outlet Data",
  },
  {
    term: "Part of Chain",
    definition: "A Boolean column determining if the location is part of a chain (based on Franchise list, chain name, and name occurrence).",
    category: "Outlet Data",
  },
  {
    term: "Platform",
    definition: "The platform in which the Digital Storefront was found (e.g., UberEats).",
    category: "Outlet Data",
  },
  {
    term: "Postal Code",
    definition: "The postal code in which the Digital Storefront is found.",
    category: "Outlet Data",
  },
  {
    term: "Price Level",
    definition: "An indicator of how expensive the store is, as told by the platform.",
    category: "Outlet Data",
  },
  {
    term: "Rating",
    definition: "The rating coming from the platform.",
    category: "Outlet Data",
  },
  {
    term: "Reviews",
    definition: "The number of reviews left for the Digital Storefront.",
    category: "Outlet Data",
  },
  {
    term: "Segment Type",
    definition: "Segments the Digital Storefront into Restaurant and Non-Restaurant.",
    category: "Outlet Data",
  },
  {
    term: "URL (Link)",
    definition: "The URL of the specific Digital Storefront on a specific platform.",
    category: "Outlet Data",
  },

  // Portfolio Data
  {
    term: "Availability",
    definition: "Yes or no, is the location listing my drinks?",
    category: "Portfolio Data",
  },
  {
    term: "Competitor",
    definition: "Yes or no, is the location listing the competition's drinks?",
    category: "Portfolio Data",
  },
  {
    term: "Core Brand Availability Percentage",
    definition: "The percentage of my core brands sold in the location.",
    category: "Portfolio Data",
  },
  {
    term: "Specific Core Brand Availability Columns",
    definition: "Boolean columns for each core brand selected (1-8), representing if the store is listing that specific core brand.",
    category: "Portfolio Data",
  },
  {
    term: "Combo",
    definition: "Yes or no, is the location listing my drinks in a combo?",
    category: "Portfolio Data",
  },
  {
    term: "Fixed Combo",
    definition: "Yes or no, is the location listing my drinks in a fixed combo?",
    category: "Portfolio Data",
    exampleImage: "fixed combo example.png",
  },
  {
    term: "Option Combo",
    definition: "Yes or no, is the location listing my drinks in an option combo?",
    category: "Portfolio Data",
    exampleImage: "option combo example.png",
  },
  {
    term: "Name Completeness (Portfolio)",
    definition: "0-100%, what's the average name completeness score across all my SKUs sold in the location?",
    category: "Portfolio Data",
    exampleImage: "name completeness example.png",
  },
  {
    term: "Image Presence (Portfolio)",
    definition: "0-100%, what's the average image presence score across all my SKUs sold in the location?",
    category: "Portfolio Data",
    exampleImage: "image presence example.png",
  },

  // User Roles
  {
    term: "Super Admin",
    definition: "The highest user level; allowed to see all markets, add users, change core brands, and change DashONE weights.",
    category: "User Roles",
  },
  {
    term: "Admin",
    definition: "Allowed to add users and change core brands, but not allowed to change DashONE weights (usually a region leader).",
    category: "User Roles",
  },
  {
    term: "Regular User",
    definition: "Can see as many markets as they are added to, but cannot change core brands or DashONE weights.",
    category: "User Roles",
  },
];

export const categories = [
  "All Categories",
  "Core concept",
  "Core View",
  "Dashboard Feature",
  "KPIs (ONE Metrics)",
  "KPIs (Scorecard)",
  "Market Deepdive View",
  "Execution View",
  "Outlet Data",
  "Portfolio Data",
  "User Roles",
];

export const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

// Look up an example image filename for a metric/term, if one exists.
// Used by surfaces outside the glossary page (Execution View column headers,
// Market Overview Metrics modal) to surface the same "see example" image
// without duplicating the term→image mapping.
export const getExampleImageForMetric = (term) =>
  glossaryTerms.find((entry) => entry.term === term)?.exampleImage;

